import types from "./types";
import produce from "immer";

const initialState = {
  layouts: [
    {
      name: 'パターン1',
      image: 'card-p-1.png',
      objects: [
        {
          id: 'company',
          label: '会社名',
          x: 0.07,
          y: 450 / 970,
          fontSize: 33,
          sample: '長屋印刷株式会社'
        },
        {
          id: 'division1',
          label: '部署名',
          x: 0.07,
          y: 493/ 970,
          fontSize: 28,
          sample: '営業部'
        },
        {
          id: 'title',
          label: '役職名',
          x: 0.07,
          y: 556 / 970,
          fontSize: 28,
          sample: '代表取締役'
        },
        {
          id: 'name',
          label: '氏名',
          x: 0.07,
          y: 594 / 970,
          fontSize: 39,
          sample: '長屋　太郎'
        },
        {
          id: 'ruby',
          label: 'ふりがな/ローマ字',
          x: 0.07,
          y: 642 / 970,
          fontSize: 24,
          sample: 'Taro Nagaya'
        },
        {
          id: 'zipcode',
          label: '郵便番号',
          x: 0.07,
          y: 737 / 970,
          fontSize: 28,
          sample: '〒999-9999'
        },
        {
          id: 'address1',
          label: '住所',
          x: 0.07,
          y: 774 / 970,
          fontSize: 28,
          sample: '愛知県名古屋市東区泉3-30-23'
        },
        {
          id: 'tel1',
          label: '電話番号',
          x: 0.07,
          y: 812 / 970,
          fontSize: 28,
          sample: 'TEL 999-999-9999'
        },
        {
          id: 'email',
          label: 'メールアドレス',
          x: 0.07,
          y: 850 / 970,
          fontSize: 28,
          sample: 'info@t-meishi-project.com'
        }
      ]
    },
    {
      name: 'パターン2',
      image: 'card-p-1.png',
      objects: [
        {
          id: 'name',
          label: '氏名',
          x: 0.07,
          y: 544 / 970,
          fontSize: 39,
          sample: '長屋　太郎'
        },
        {
          id: 'ruby',
          label: 'ふりがな/ローマ字',
          x: 0.07,
          y: 592 / 970,
          fontSize: 24,
          sample: 'Taro Nagaya'
        },
      ]
    },
    {
      name: 'パターン3',
      image: 'card-p-1.png',
      objects: [
        {
          id: 'company',
          label: '会社名',
          x: 0.07,
          y: 450 / 970,
          fontSize: 33,
          sample: '長屋印刷株式会社'
        },
        {
          id: 'division1',
          label: '部署名',
          x: 0.07,
          y: 493/ 970,
          fontSize: 28,
          sample: '営業部'
        },
        {
          id: 'name',
          label: '氏名',
          x: 0.07,
          y: 594 / 970,
          fontSize: 39,
          sample: '長屋　太郎'
        },
        {
          id: 'ruby',
          label: 'ふりがな/ローマ字',
          x: 0.07,
          y: 642 / 970,
          fontSize: 24,
          sample: 'Taro Nagaya'
        },
      ]
    }
  ],
  currentLayout: 0,
  values: {},
  fontSizes: {},
  amounts: [],
  imageFile: null,
  previewUrl: null,
  prices: [
    {amount: 20, price: 1320, unit: 66.0},
    {amount: 60, price: 2530, unit: 42.1},
    {amount: 100, price: 2970, unit: 29.7},
    {amount: 200, price: 4950, unit: 24.7},
  ],
  amount: 20,
  totalPrice: 2090,
  backupImage: null
};

const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case types.CHANGE_LAYOUT:
      return produce(state, draftState => {
        draftState.currentLayout = action.payload.index;
      });
    case types.SET_VALUE:
      return produce(state, draftState => {
        draftState.values[action.payload.id] = action.payload.value;
      });
    case types.SET_FONT_SIZE:
      return produce(state, draftState => {
        draftState.fontSizes[action.payload.id] = action.payload.value;
      });
    case types.SET_IMAGE:
      return produce(state, draftState => {
        draftState.imageFile = action.payload.file;
        draftState.previewUrl = action.payload.previewUrl
      });
    case types.SET_BACKUP_IMAGE:
      return produce(state, draftState => {
        draftState.backupImage = action.payload.url;
      });
    case types.CHANGE_AMOUNT:
      return produce(state, draftState => {
        draftState.amount = action.payload.amount;
        draftState.totalPrice = action.payload.price + 770;
      });
    default:
      return state;
  }
};

export default reducer;